import React, { FC, useState } from 'react'
import moment from 'moment'
import { Button } from 'transfix-ui/components/Button'
import { RangeDatePicker } from 'transfix-ui/components/RangeDatePicker'
import { Box } from 'transfix-ui/core'

interface IDateRangeFilterProps {
  onChange: (dates: Date[]) => void
  startDate?: string | null
  endDate?: string | null
  onlyFutureDates?: boolean
}

const TODAY = moment().startOf('day').toDate()
const TOMORROW = moment().add(1, 'days').toDate()

/** Date range filter */
export const DateRangeFilter: FC<IDateRangeFilterProps> = ({
  endDate: endDateProp,
  onChange,
  onlyFutureDates: onlyFutureDatesProp,
  startDate: startDateProp,
}) => {
  const startDate = startDateProp ? moment(startDateProp).toDate() : TODAY
  const endDate = endDateProp ? moment(endDateProp).toDate() : TOMORROW
  const initialDates = startDateProp && endDateProp ? [startDate, endDate] : []
  const [dates, setDates] = useState<Date[]>(initialDates)
  const datesHandler = (dateArr: Date[]) => {
    const [start, end] = dateArr || []
    setDates([start, end])
  }
  const submitHandler = () => {
    onChange(dates)
  }

  return (
    <Box>
      <RangeDatePicker
        label='Dates'
        placeholder='Date range'
        dateFormat='m-d-Y'
        dates={dates}
        onDateChange={datesHandler}
        minDate={onlyFutureDatesProp ? TODAY : undefined}
        large
      />
      <Box mt={3}>
        <Button color='primary' size='large' fullWidth onClick={submitHandler}>
          Apply Filter
        </Button>
      </Box>
    </Box>
  )
}
